export default __webpack_public_path__ + "static/media/pexels-nataliya-vaitkevich-6120166-min.01b8d2ea.jpg";